import React from 'react';
import _ from 'lodash';
import autoBind from 'react-autobind';
import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';
import N from '@common/constraints/numbers.contraints';

import Field from '@common/components/validation/field.validation';
import PercentageInput from '@common/components/inputs/percentage.component';
import PercentageFormat from '@common/components/formats/percentage.format';
import { PercentageOutlined } from '@ant-design/icons';
import commonMessages from '@common/constraints/common.messages';
import { OverlayTrigger, Tooltip as TooltipBootstrap } from 'react-bootstrap';

import FocusHelper from '@common/helpers/focus.helper';

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  validate(floatValue) {
    if (!floatValue) floatValue = 0;
    const { Maximo, Minimo, MaiorQue } = this.props;
    if (floatValue || floatValue.toString() == '0') {
      let maxNumber;
      if (Maximo) maxNumber = Maximo;
      else maxNumber = N.MAX_DECIMAL;
      if (floatValue > maxNumber) return commonMessages.validations.MAX_INVALID(maxNumber);

      let minNumber;
      if (Minimo) minNumber = Minimo;
      else minNumber = N.MIN_DECIMAL;
      if (floatValue < minNumber) return commonMessages.validations.MIN_INVALID(minNumber);

      if (!isNaN(MaiorQue) && floatValue <= MaiorQue) return commonMessages.validations.MIN_INVALID(MaiorQue);
    }
  }

  componentDidMount() {
    this.setFocus();
  }

  setFocus() {
    const { name, setFocus } = this.props;
    if (setFocus) FocusHelper.focus(name);
  }

  renderComponent() {
    const { props, validate } = this;
    const {
      Maximo,
      Minimo,
      Negativo,
      Placeholder,
      CasasDecimais,
      Label,
      Tooltip,
      Obrigatorio,
      Desabilitado,
      Tamanho,
      name,
      onKeyDown,
      PlacementTooltip,
      TextLeft,
    } = props;

    return (
      <Field {...props} validate={validate}>
        {({ value, hasError, onChangeAsync, onBlur }) => {
          return (
            <LabeledInput {...props}>
              <OverlayTrigger
                key={`top-${name}`}
                placement={PlacementTooltip || 'top'}
                overlay={
                  <TooltipBootstrap id={`tooltip-${name}`}>
                    <div className={'fontTooltip'}>{Tooltip || Label}</div>
                  </TooltipBootstrap>
                }
              >
                <div className="d-flex">
                  <PercentageInput
                    name={name}
                    value={value ?? 0}
                    className={`form-control ${TextLeft == true ? '' : 'text-right'} position-relative pr-4 ${hasError ? 'form-invalid' : ''}`}
                    disabled={Desabilitado}
                    required={Obrigatorio}
                    onValueChange={({ floatValue }) => {
                      onChangeAsync(floatValue);
                    }}
                    onBlur={onBlur ? onBlur : this.handleOnBlur}
                    max={Maximo}
                    min={Minimo}
                    allowNegative={Negativo}
                    tamanho={Tamanho}
                    placeHolder={Placeholder || Label}
                    places={CasasDecimais || 2}
                    onKeyDown={onKeyDown}
                  />
                </div>
              </OverlayTrigger>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderView() {
    return (
      <Field {...this.props}>
        {(field) => {
          return (
            <LabeledInput {...this.props} Obrigatorio={false}>
              <span>
                <label className="form-control">
                  <PercentageFormat value={field.value} places={this.props.CasasDecimais} textLeft={this.props.TextLeft} />
                </label>
              </span>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderHeader() {
    return (
      <div>
        <Field {...this.props}>
          {(field) => {
            return (
              <label style={{ fontWeight: 'bold', display: 'flex' }}>
                {this.props.Label}:
                <label style={{ marginLeft: '5px' }}>
                  <PercentageFormat value={field.value} places={this.props.CasasDecimais} textLeft={this.props.TextLeft} />
                </label>
              </label>
            );
          }}
        </Field>
      </div>
    );
  }
}

export default DDadosComponent;
